import GlobalMenuButton from './global-menu-button';
import GlobalMenuItem from './global-menu-item';

let defaultServices = null;

export default class GlobalServicesMenuButton extends GlobalMenuButton {

  render(template, defaultOptions) {
    super.render(template, defaultOptions);
    defaultServices = defaultOptions;

    let titleElement = this.element.querySelector('.dt-gnm-menu-button__title');
    titleElement.textContent = 'Service';

    let subtitleElement = this.element.querySelector('.dt-gnm-menu-button__current_option');
    let currentService = defaultServices[this.currentService];
    if (currentService) {
      subtitleElement.textContent = currentService.title;
    } else {
      this.element.classList.add('no-service');
      subtitleElement.textContent = 'Services';
    }
  }

  get menuItems() {
    // TODO: Support services option as array for manual initialization
    const configuredServices = this.services ? this.services.split(/[^(!)?(A-Z)]+/) : Object.keys(defaultServices);
    const servicesToShow = configuredServices.filter((x) => {
      let serviceIdentifier = (x.indexOf('!') === 0) ? x.slice(1) : x;
      return Object.keys(defaultServices).indexOf(serviceIdentifier) !== -1;
    });

    return servicesToShow.map((service) => {
      let serviceDisabled = (service.indexOf('!') === 0);
      let serviceIdentifier = serviceDisabled ? service.slice(1) : service;

      let configurationService = defaultServices[serviceIdentifier];
      configurationService.enabled = !serviceDisabled;

      const serviceInstance = new GlobalMenuItem(configurationService);
      if (serviceIdentifier == this.currentService) {
        serviceInstance.selected = true;
      }

      return serviceInstance.render();
    });
  }

}



// WEBPACK FOOTER //
// ./src/scripts/global-services-menu-button.js